import React, { ReactNode } from 'react';

import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@material-ui/core';
import { FiChevronDown } from 'react-icons/fi';

import useStyles from '../../styles';

interface Props {
  title: string;
  /** Shown under the title while nothing is selected */
  description: string;
  icon: ReactNode;
  selectedCount: number;
  expanded: boolean;
  onToggle: () => void;
  /** Replaces the "N selected" caption while the section is incomplete */
  error?: string | null;
  children: ReactNode;
}

/** One module on the "Where" step — a collapsible card so all three module headers fit a dialog. */
export const TargetSection: React.FC<Props> = ({
  title,
  description,
  icon,
  selectedCount,
  expanded,
  onToggle,
  error,
  children,
}) => {
  const classes = useStyles();

  const caption = error ? (
    <Typography className={classes.sectionError}>{error}</Typography>
  ) : (
    <Typography className={classes.sectionCaption}>
      {selectedCount > 0 ? `${selectedCount} selected` : description}
    </Typography>
  );

  return (
    <Accordion
      classes={{ root: classes.moduleCard, expanded: classes.moduleCardExpanded }}
      expanded={expanded}
      onChange={onToggle}>
      <AccordionSummary
        classes={{ content: classes.summaryContent }}
        expandIcon={<FiChevronDown size="22px" />}
        aria-controls={`${title}-targets`}>
        <Box display="flex" alignItems="center" gridGap={12}>
          <Box className={classes.moduleIcon}>{icon}</Box>
          <Box display="flex" flexDirection="column">
            <Typography className={classes.sectionTitle}>{title}</Typography>
            {caption}
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails classes={{ root: classes.moduleDetails }}>
        <Box width="100%">{children}</Box>
      </AccordionDetails>
    </Accordion>
  );
};
